
export interface IProductCategoryModel{
  id: number;
  name: string;
  image: string;
  description:string;
  products: IProductModel[];
  modifierGroups:IModifierGroupModel[]
}
export interface IModifierGroupModel{
  modifierGroupId: number;
  name: string;
  sort: number;
  selectType:SelectGroupTypeEnum;
  modifiers:IProductModel[];
  isRequired:boolean;
}
export enum SelectGroupTypeEnum{
  Single,
  Multiple,
}
export interface IProductModel {
  id: number;
  sort: number;
  name: string;
  images: string[];
  slug: string;
  skuCode: string;
  sellingPrice: number;
  description: string;
  label: string;
  notAdded:boolean;
  variationAttributes: IVariationAttributeModel[];
  variationProducts: IProductModel[];
}
export interface IVariationAttributeModel{
  variationId: number;
  variationName: string;
  variationValueId: number;
  variationValueName: string;
}





